import http from "./httpService";

const apiEndpoint = "/client";

export function checkNetworkHealth() {
  return http.get(apiEndpoint + "/health", { suppressGlobalError: true });
}
